import { useNavigate } from 'react-router-dom'
import { Table } from 'reactstrap'
import { enterKeyHandler } from '../../../utils'
import useForm from '../../CustomHooks/FormHook'
import '../Custom.css'
import { initialFormValues, stringifyInputs, submitFormValues } from '../CustomUtils'
import DateRangeInput from '../DateRangeInput'
import FormHeading from '../FormHeading'
import FormSubmitButton from '../FormSubmitButton'

export default function LibertyMutualDefenseFeesForm({ location }) {
  console.log('LibertyMutualDefenseFeesForm rendered: ', location)

  let init = {
    invoiceDateFrom: '',
    invoiceDateTo: '',
    invoicePaidFrom: '',
    invoicePaidTo: '',
  }

  const navigate = useNavigate()
  init = initialFormValues('LibertyMutualDefenseFeesForm', navigate, init)
  const { inputs, handleInputChange, handleSubmit } = useForm(init, submitSearch, enterKeyHandler(submitSearch))

  async function submitSearch() {
    console.log('LibertyMutualDefenseFeesForm.submitSearch', inputs)
    if (location.search.includes('in_show_status=Y')) {
      inputs.showStatus = 'Y'
    }
    submitFormValues('LibertyMutualDefenseFeesForm', navigate, inputs, 'liberty_mutual.liberty_mutual_month_rep')
    let queryString = `/custom/liberty_mutual.liberty_mutual_month_rep?inputs=${stringifyInputs(inputs)}`
    navigate(queryString)
  }

  return (
    <div className="custom-scroll">
      <form className="form" onSubmit={handleSubmit}>
        <div>
          <Table bordered className="custom-table custom-form-table" style={{backgroundColor: 'white'}}>
            <FormHeading headingText='Paid Defense Fees Report' />
            <tbody>
              <DateRangeInput label='Invoice Date' name='invoiceDate' handleInputChange={handleInputChange} defaultValueFrom={inputs.invoiceDateFrom} defaultValueTo={inputs.invoiceDateTo} />
              <DateRangeInput label='Invoice Paid Date' name='invoicePaid' handleInputChange={handleInputChange} defaultValueFrom={inputs.invoicePaidFrom} defaultValueTo={inputs.invoicePaidTo} />
              <tr>
                <td colSpan={2}><b>Note:</b> the "Date Filed" column shows data from the "Date Assigned" field.</td>
              </tr>
            </tbody>
          </Table>
        </div>
        <FormSubmitButton />
      </form>
    </div>
  )
}

